/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
import { ToolOptions, ModalBody, Wrap, ChangeCursor, InsertTextareaGb } from './styles';

import 'leaflet-path-drag';
import geoAlert from 'services/utils/alert';
import geoConfirm from 'services/utils/confirm';

import {  
  InsertTextIcon,  
  CheckIcon,
  TrashIcon,
} from './components/Icons';
import toolReducer, { initialToolState } from './services/toolReducer';

import ButtonTooltip from '@map/components/ToolBar/components/ButtonTooltip';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
/**
 * Turf é uma coleção de módulos com algoritmos geográficos.
 */
import * as turf from '@turf/turf';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 * 
 * useReducer é um hook parecido com o useState, ele permite a logica
 * de estado personalizada, para acompanhar varios pedaços de estado
 * que dependem de logia complexa o useReducer é indicado.
 * 
 * useCallback é um hook que retorna uma função de retorno
 * de chamada memorizada
 */
import { useState, useEffect, useReducer, useCallback } from 'react';
import SimpleModal from 'views/MapView/components/SimpleModal';
import SliderColorPicker from 'views/MapView/components/SliderColorPicker';
/**
 *  *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 * 
 *  useModules é responsavel por gerenciar os modulos do GeoBahia,
 *  todos os módulos criados na ADM.
 */
import { useMap, useModule } from 'views/MapView/hooks';


/**
 * Função responsável por inserir pontos, linhas, poligonos e circulos no mapa, atráves
 * do cursor, podendo criar varias figuras contento a medida de cada uma, nescessario 
 * clicar no ponto inicial após fazer a figura para que a mesma fique salva no mapa.
 * 
 * @param {string} mapContext Context
 * @param {boolean} isActive Verificação
 * @param {boolean} setIsActive Seta o estado
 * @returns um menu com as opções das figuras apos clicar em uma delas o cursor do mouse 
 * muda para uma mira de bola com exeção do ponto que o cursor vira um ponto. Possibilitando
 * fazer figuras por todo o mapa e nela contento as medidas da area selecionada.
 */
export const InsertText = ({ mapContext, isActive, setIsActive }) => {
  const [toolState, toolDispatch] = useReducer(toolReducer, initialToolState);

  // Estados de SUBMENU
  const [anchorToolOptions, setAnchorToolOptions] = useState(null);
  useEffect(() => {
    if (!isActive) setAnchorToolOptions(null);
  }, [isActive]);

  const mapCtx = useMap(); // hook personalizado para gerenciar a comunicação dos componentes com o mapa.
  const { getElement, activeModule } = useModule();
  const { map } = mapCtx; // hook personalizado para gerenciar a comunicação dos componentes com o mapa.


  const handleSelectItem = (item) => {
    toolDispatch({ type: 'selectOrToogleActiveItem', payload: item });
  };
  
  const checkGeometryLimit = useCallback(
    (layerToCheck) => {
      let geometryLimit = getElement(InsertText.properties.id)?.configuracao
        .geometryLimit;
      if (geometryLimit) {
        let layerArea = turf.area(layerToCheck);
        let intersectResult = turf.intersect(layerToCheck, geometryLimit);
        let intersectArea = intersectResult ? turf.area(intersectResult) : 0;
        if ((100 / layerArea) * intersectArea < 90) {
          geoAlert({
            message:
              getElement(InsertText.properties.id)?.configuracao
                .geometryLimitMessage ||
              'A geometria deve estar contida dentro do limite!',
          });
          return false;
        }
      }
      return true;
    },
    [getElement]
  );

  // Handle de listeners create e drawstart do geoman
  // ? Migrar para o useReducer
  useEffect(() => {
    
    const onCreateFeatureText = (e) => {  
      let textAreaElement = e.layer.pm.getElement(); 
      textAreaElement.maxLength = 50;

      // e.layer.on('pm:textchange', (event) => {  
      //   textAreaElement.style.width = textAreaElement.offsetWidth >= 25 
      //                                   ? textAreaElement.offsetWidth + 8 + "px"
      //                                   : textAreaElement.offsetWidth;
      // });

      e.layer.on('dblclick', (event) => {  
        textAreaElement.style.border = 'dashed 2px #3C71DD';          
        e.layer.pm.enable();
        e.layer.pm.focus();        
      });

      e.layer.on('pm:textblur', (event) => {
        if ( textAreaElement.value.length === 0 ) {                    
          toolDispatch({
            type: 'deleteFeature',
            payload: e.layer._leaflet_id,
          });          
        } else {          
          e.layer.dragging.enable();
          e.layer.pm.disable();
        }
        
        toolDispatch({ type: 'selectOrToogleActiveItem', payload: null });
                
      });

      toolDispatch({ type: 'selectFeature', payload: e.shape });
      toolDispatch({
        type: 'addFeature',
        payload: e.layer,
      });
      
    };

    if (isActive && toolState.activeItem) {
      if (toolState.activeItem === 'Text') {
        map.on('pm:create', onCreateFeatureText);        
        map.pm.enableDraw("Text", {
          textOptions: { 
            className: "insertTextareaGb"             
          },          
          cursorMarker: false,
        });
      } 
    } else {
      map.pm.disableDraw();
      if (toolState.activeItem)
        toolDispatch({ type: 'selectOrToogleActiveItem', payload: null });
    }
    return () => {      
      map.off('pm:create', onCreateFeatureText);      
    };
  },[
     toolState.activeItem,
     isActive, map, 
     toolState.features, 
     getElement, 
     checkGeometryLimit
    ]);

  // Observando se a ferramenta está ativa ou se tem feature criada
  useEffect(() => {
    if (!isActive && toolState.features.length) {
      toolState.features.forEach((l) => l.remove());
      toolDispatch({ type: 'setFeatures', payload: [] });
      toolDispatch({ type: 'selectFeature', payload: null });
    } else if (isActive && !toolState.features.length) {
      toolDispatch({ type: 'selectFeature', payload: null });
    }
  }, [toolState.features, isActive]);

  return (
    <Wrap>
      {toolState.activeItem && toolState.activeItem !== 'Marker' && (
        <ChangeCursor />
      )}
      <InsertTextareaGb />
      <ButtonTooltip
        tooltip={InsertText.properties.alias}
        description={InsertText.properties.description}
        onClick={(e) => {                    
          setIsActive(!isActive);
          setAnchorToolOptions(anchorToolOptions ? null : e.currentTarget);
        }}
        tooltipDisabled={isActive}
        active={isActive}
      >
        <InsertTextIcon />
      </ButtonTooltip>
      <ToolOptions open={isActive} anchorEl={anchorToolOptions}>       
        {activeModule &&
          getElement(InsertText.properties.id)?.configuracao.polygon !== false && (
            <ButtonTooltip
              tooltip="Inserir texto"
              onClick={() => {
                handleSelectItem('Text');
              }}
              active={toolState.activeItem === 'Text'}
              activeWithBgColor
              disabled={
                ![null, 'Text'].includes(toolState.selectedFeature)
              }
            >
              <InsertTextIcon />
            </ButtonTooltip>
          )}        
        <hr />
        <ButtonTooltip
          tooltip="Remover todas as geometrias"
          disabled={toolState.selectedFeature === null}
          activeWithBgColor
          onClick={() => {
            handleSelectItem(null);
            geoConfirm({
              message:
                'A(s) geometria(s) será(ão) apagadas. Deseja continuar?',
              callback: (confirmed) => {
                if (confirmed) {
                  toolDispatch({
                    type: 'deleteAllFeatures',
                    payload: { silent: true },
                  });
                }
              },
            });
          }}
        >
          <TrashIcon />
        </ButtonTooltip>
        <ButtonTooltip
          tooltip="Salvar"
          disabled={toolState.selectedFeature === null}
          activeWithBgColor
          onClick={() => {
            let checkLimit = true;
            toolState.features.forEach((f) => {
              if (!checkGeometryLimit(f.toGeoJSON())) checkLimit = false;
            });

            if (checkLimit) {
              handleSelectItem(null);
              toolDispatch({ type: 'openSaveModal' });
            }
          }}
        >
          <CheckIcon />
        </ButtonTooltip>
      </ToolOptions>
      <SimpleModal
        title="Salvar Camada"
        activeWithBgColor
        open={toolState.displaySaveModal}
        onClose={() => {
          toolDispatch({ type: 'closeSaveModal' });
        }}
      >
        <ModalBody>
          <TextField
            id="layer-name"
            label="Nome da camada"
            variant="outlined"
            size="small"
            fullWidth
            inputProps={{ maxlength: 70 }}
            value={toolState.layerNameToSave}
            onChange={(e) => {
              toolDispatch({
                type: 'setLayerNameToSave',
                payload: e.target.value,
              });
            }}
            error={Boolean(toolState.saveLayerNameError)}
            helperText={toolState.saveLayerNameError}
          />
          <SliderColorPicker
            geometryType={
              toolState.selectedFeature === 'Marker' || toolState.selectedFeature === 'Text'
                ? 'Point'
                : toolState.selectedFeature === 'Circle'
                ? 'Polygon'
                : toolState.selectedFeature
            }
            selectedSymbology={toolState.layerStyleToSave}
            onSelect={(style) =>
              toolDispatch({
                type: 'setLayerStyleToSave',
                payload: style,
              })
            }
          />
          <p style={{ marginLeft: 9 }}>
            Após salvar o desenho não será permitido editá-lo.
          </p>
          <div style={{ margin: '32px auto 0', width: '185.14px' }}>
            <Button
              variant="contained"
              color="primary"
              component="div"
              onClick={() => {
                toolDispatch({
                  type: 'saveAsLayer',
                  payload: {
                    mapContext: mapCtx,
                    callback: ({ error }) => {
                      if (!error) {
                        setIsActive(false);
                        setAnchorToolOptions(null);
                      }
                    },
                  },
                });
              }}
            >
              Salvar
            </Button>
          </div>
        </ModalBody>
      </SimpleModal>
    </Wrap>
  );
};

InsertText.properties = {
  id: 'CPN-TB-T-INSERT-TEXT',
  alias: 'Inserir Texto',
  description:
    'Insere textos digitados no mapa.',  
};

export default InsertText;
